import { ChangeDetectionStrategy, Component, input, inject, computed } from '@angular/core';
import { FileType } from '@bazis/form/models/form-element.types';
import { BazisModalService } from '@bazis/shared/services/modal.service';
import { DocListItem } from '@bazis/shared/models/document.types';
import { BazisConfigurationService } from '@bazis/configuration.service';
import { BazisDocuSignaturesComponent } from '@bazis/document/component/docu-signatures.component';
import { BazisSignaturesComponent } from '@bazis/document/component/signatures.component';
import { CommonModule } from '@angular/common';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { TooltipModule } from '@bazis/shared/components/web/tooltip/tooltip.module';
import { FileSizePipe } from '@bazis/shared/pipes/file-size.pipe';
import { LinkModule } from '@bazis/shared/components/web/link/link.module';
import { BadgeModule } from '@bazis/shared/components/web/badge/badge.module';
import { TranslocoModule } from '@jsverse/transloco';
import { ColorDirective } from '@bazis/shared/directives/color.directive';

@Component({
    selector: 'bazis-signed-file-inline',
    templateUrl: './signed-file-inline.component.html',
    imports: [
        CommonModule,
        IconModule,
        ButtonModule,
        TooltipModule,
        FileSizePipe,
        LinkModule,
        BadgeModule,
        TranslocoModule,
        ColorDirective,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignedFileInlineComponent {
    public modalService = inject(BazisModalService);

    public configurationService = inject(BazisConfigurationService);

    readonly filesData = input<DocListItem>();

    readonly fileNameKey = input<string>('');

    readonly fileNameParams = input<any>(null);

    readonly hasLink = input<boolean>(true);

    readonly showFileSize = input<boolean>(true);

    readonly showSignatures = input<boolean>(true);

    // знак вопроса может быть рядом с файлом
    readonly tooltipKey = input<string>();

    // параметры для tooltip
    readonly tooltipParams = input<any>(null);

    public fileType: FileType = 'any';

    openDropdownMenu = false;

    componentTypes = {
        crypto: BazisSignaturesComponent,
        NCALayer: BazisSignaturesComponent,
        docusign: BazisDocuSignaturesComponent,
    };

    srcFile = computed(() => {
        if (!this.filesData()) return null;
        return (
            this.filesData().displayDocument.$snapshot.file_upload_url ||
            this.filesData().displayDocument.$snapshot.file
        );
    });

    extension = computed(() => {
        if (!this.srcFile()) return null;
        const extensionArr = this.srcFile().split('.');
        const extension = extensionArr[extensionArr.length - 1];
        return extension.split('?')[0];
    });

    openSignatureDetails() {
        const component = this.componentTypes[this.configurationService.signatureType || 'crypto'];

        this.modalService.create({
            component,
            componentProperties: {
                document: this.filesData().popupDocument,
                signInfo: this.filesData().signInfo,
                site: location.host,
            },
        });
    }

    toggleMenu(event) {
        this.openDropdownMenu = !this.openDropdownMenu;
        event.stopPropagation();
    }
}
